module.exports = __webpack_public_path__ + "4a68e1e8bfd2c4ceeb4de2f9f580f300.png";